import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  breakpoints: {
    sm: "30em", // 480px
    md: "48em", // 768px
    lgCustom: "53.125em", // 850px (850 / 16 = 53.125)
    lg: "62em", // 992px
    xl: "80em", // 1280px
    "2xl": "96em", // 1536px
  },
  colors: {
    "electric-blue": "#0066FF",
    "dark-grey": "#222222",
    "light-grey": "#F5F7FA",
    "yellow-400": "#FACA15",
    "green-500": "#22C55E",
  },
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
    poppins: `'Poppins', sans-serif`,
  },
  textStyles: {
    h1: {
      fontSize: ["3xl", "4xl", "5xl", "6xl", "7xl"],
      "@media screen and (min-width: 62em)": {
        fontSize: "clamp(3.75rem, 6vw, 5.5rem)",
      },
      fontWeight: "extrabold",
      lineHeight: "tight",
    },
    h2: {
      fontSize: ["2xl", "3xl", "4xl", "5xl"],
      fontWeight: "bold",
      lineHeight: "shorter",
    },
    h3: {
      fontSize: ["xl", "2xl", "3xl"],
      fontWeight: "semibold",
      lineHeight: "short",
    },
    bodyLarge: {
      fontSize: ["md", "lg", "xl"],
      lineHeight: "tall",
    },
    bodyRegular: {
      fontSize: ["sm", "md", "lg"],
      lineHeight: "base",
    },
    small: {
      fontSize: ["xs", "sm"],
      lineHeight: "normal",
    },
  },
  components: {
    Button: {
      variants: {
        "glow-button": {
          bg: "electric-blue",
          color: "white",
          px: { base: "6", md: "8" },
          py: { base: "3", md: "4" },
          borderRadius: "full",
          fontWeight: "bold",
          fontSize: { base: "md", md: "lg" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease",
          animation: "glow 2s infinite alternate",
          _hover: {
            bg: "blue.700",
          },
        },
        "secondary-hero": {
          bg: "whiteAlpha.100",
          color: "white",
          border: "1px solid",
          borderColor: "whiteAlpha.300",
          px: { base: "6", md: "8" },
          py: { base: "3", md: "4" },
          borderRadius: "full",
          fontWeight: "bold",
          fontSize: { base: "md", md: "lg" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s",
          _hover: {
            bg: "whiteAlpha.200",
          },
        },
        "dark-button": {
          bg: "dark-grey",
          color: "white",
          px: { base: "6", md: "8" },
          py: { base: "3", md: "4" },
          borderRadius: "full",
          fontWeight: "bold",
          fontSize: { base: "md", md: "lg" },
          display: "inline-flex",
          alignItems: "center",
          transition: "all 0.2s",
          _hover: {
            bg: "black",
          },
        },
        "light-button": {
          bg: "white",
          color: "electric-blue",
          px: { base: "6", md: "8" },
          py: { base: "3", md: "4" },
          borderRadius: "full",
          fontWeight: "bold",
          fontSize: { base: "md", md: "lg" },
          display: "inline-flex",
          alignItems: "center",
          transition: "all 0.2s",
          _hover: {
            bg: "gray.100",
          },
        },
        "pricing-free": {
          bg: "white",
          border: "2px solid",
          borderColor: "electric-blue",
          color: "electric-blue",
          textAlign: "center",
          py: "3",
          borderRadius: "full",
          fontWeight: "bold",
          transition: "all 0.2s",
          _hover: {
            bg: "electric-blue.50",
          },
        },
        "pricing-pro": {
          bg: "white",
          color: "electric-blue",
          textAlign: "center",
          py: "3",
          borderRadius: "full",
          fontWeight: "bold",
          transition: "all 0.2s",
          _hover: {
            bg: "gray.100",
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: "2xl",
          boxShadow: "lg",
          overflow: "hidden",
          transition: "all 0.3s ease",
          _hover: {
            transform: "translateY(-8px)",
            boxShadow:
              "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          },
        },
      },
    },
  },
  styles: {
    global: {
      html: {
        scrollBehavior: "smooth",
      },
      body: {
        bg: "white",
        "@keyframes glow": {
          from: { boxShadow: "0 0 5px rgba(0, 102, 255, 0.5)" },
          to: { boxShadow: "0 0 20px rgba(0, 102, 255, 0.8)" },
        },
      },
    },
  },
})

export default theme
